export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const ADD_MENU_ITEM = 'ADD_MENU_ITEM'
export const REMOVE_MENUS = 'REMOVE_MENUS'
export const USER_INFORMATION = 'USER_INFORMATION'
export const REMOVE_USER_INFORMATION = 'REMOVE_USER_INFORMATION'
// export const CHANGE_LOCALES     = 'CHANGE_LOCALES'
